import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/Toaster';

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[var(--z-modal)] focus:rounded-md focus:bg-[var(--color-surface-elevated)] focus:px-4 focus:py-2 focus:shadow-[var(--shadow-md)]"
      >
        Skip to main content
      </a>
      <Outlet />
      <Toaster />
    </>
  );
}
